import { createContext, useContext } from "react";
import { TestAttributePrefix } from "./TestAttributePrefix";

export const TestContext = createContext<TestAttributePrefix>(null!);

export const useTestContext = () => useContext(TestContext);
